/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tame_Vast_Hawk_DripInputs */

const en_tame_vast_hawk_drip = /** @type {(inputs: Tame_Vast_Hawk_DripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const de_tame_vast_hawk_drip = /** @type {(inputs: Tame_Vast_Hawk_DripInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Tame_Vast_Hawk_DripInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tame_vast_hawk_drip = /** @type {((inputs?: Tame_Vast_Hawk_DripInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tame_Vast_Hawk_DripInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tame_vast_hawk_drip(inputs)
	return de_tame_vast_hawk_drip(inputs)
});